// app/javascript/projects/components/ProjectsDisplay.jsx

import React, { useState, useEffect } from 'react';

const EditableName = ({ title, onSave, placeholder, blurredPostfix }) => {
  const [localValue, setLocalValue] = useState(title || '');
  const [isFocused, setIsFocused] = useState(false);

  // Update local value when title prop changes
  useEffect(() => {
    setLocalValue(title || '');
  }, [title]);

  const handleChange = (e) => {
    setLocalValue(e.target.value);
  };

  const handleFocus = () => {
    setIsFocused(true);
  };

  const handleBlur = () => {
    const trimmedValue = localValue.trim();
    
    if (trimmedValue && trimmedValue !== title) {
      onSave(trimmedValue);
    } else if (!trimmedValue) {
      // Reset to original if empty
      setLocalValue(title || '');
    }
    
    setIsFocused(false);
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.target.blur();
    } else if (e.key === 'Escape') {
      setLocalValue(title || '');
      e.target.blur();
    }
  };

  // Add postfix only when not focused
  const displayValue = !isFocused && blurredPostfix 
    ? localValue + blurredPostfix 
    : localValue;

  return (
    <input 
      style={{
        fontSize: "1.5em",
        borderStyle: "none",
        outline: "none",
        width: "100%",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis"
      }}
      value={displayValue}
      onFocus={handleFocus}
      onChange={handleChange}
      onBlur={handleBlur}
      onKeyDown={handleKeyDown}
      placeholder={placeholder}
    />
  );
};

export default EditableName;
